import { skadetypeToString } from '../../meldskade/reducer/skadetype';
import { urler } from '../../router/router-urler';
import { Skademeldingstype } from '../../types/generated-types';
import { Skadekategori, skadekategoriToUrlPathName } from './skadekategori';

export const getAppUrl = () => document.URL.split('#')[0];

export const getExternalUrlForSkadekategori = (skadekategori: Skadekategori) =>
    `${getAppUrl()}?skadekategori=${skadekategoriToUrlPathName(skadekategori)}`;

export const getExternalUrlForSkadetype = (skadetype: Skademeldingstype) =>
    `${getAppUrl()}?skadetype=${skadetypeToString(skadetype)}`;

export const getEttersendingUrl = () => `${getAppUrl()}#${urler().ettersendingUrl}`;
